module.exports = __webpack_public_path__ + "img/2-2-2.f0709877.png";